var _g, _ellipse, _ellipse2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFreeTextCaseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 41,
    viewBox: "0 0 38 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 5.0791,
    y: 8.73047,
    width: 21.4905,
    height: 26.1916,
    fill: "#5A52C3"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.6064 4.95351H19.7335V3.80198C19.7335 3.25687 19.2915 2.8149 18.7464 2.8149H18.1764C18.0653 1.24365 16.777 0 15.2095 0C13.6789 0 12.3738 1.2651 12.2452 2.8149H11.179C10.6339 2.8149 10.1919 3.25687 10.1919 3.80198V4.95351H6.81251C4.02082 4.95351 1.71973 7.18974 1.71973 9.98143V33.634C1.71973 35.8236 3.53095 37.6084 5.72054 37.6084H24.6983C26.8879 37.6084 28.6991 35.8236 28.6991 33.634V9.98143C28.6992 7.18974 26.3981 4.95351 23.6064 4.95351ZM24.8333 32.6732C24.8333 33.1275 24.465 33.4957 24.0107 33.4957H6.40829C5.95398 33.4957 5.58575 33.1275 5.58575 32.6732V10.2178C5.58575 9.7635 5.95398 9.39527 6.40829 9.39527H24.0107C24.465 9.39527 24.8333 9.7635 24.8333 10.2178V32.6732Z",
    fill: "#5A52C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6064 4.95351H19.7335V3.80198C19.7335 3.25687 19.2915 2.8149 18.7464 2.8149H18.1764C18.0653 1.24365 16.777 0 15.2095 0C13.6789 0 12.3738 1.2651 12.2452 2.8149H11.179C10.6339 2.8149 10.1919 3.25687 10.1919 3.80198V4.95351H6.81251C4.02082 4.95351 1.71973 7.18974 1.71973 9.98143V33.634C1.71973 35.8236 3.53095 37.6084 5.72054 37.6084H24.6983C26.8879 37.6084 28.6991 35.8236 28.6991 33.634V9.98143C28.6992 7.18974 26.3981 4.95351 23.6064 4.95351ZM24.8333 32.6732C24.8333 33.1275 24.465 33.4957 24.0107 33.4957H6.40829C5.95398 33.4957 5.58575 33.1275 5.58575 32.6732V10.2178C5.58575 9.7635 5.95398 9.39527 6.40829 9.39527H24.0107C24.465 9.39527 24.8333 9.7635 24.8333 10.2178V32.6732Z",
    stroke: "#5A52C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1309 9.40234H16.8397V18.1329H14.1309V9.40234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1211 12.4136H19.8516V15.1223H11.1211V12.4136Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.10645,
    y: 30.2212,
    width: 12.76,
    height: 2.01474,
    rx: 1.00737,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.10645,
    y: 25.5203,
    width: 12.76,
    height: 2.01474,
    rx: 1.00737,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.10645,
    y: 20.8191,
    width: 12.76,
    height: 2.01474,
    rx: 1.00737,
    fill: "white"
  }))))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.6169,
    cy: 32,
    rx: 9.11688,
    ry: 9,
    fill: "#8C86DF"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.6169,
    cy: 32,
    rx: 9.11688,
    ry: 9,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.9166 31.6967L28.9166 28.4811C28.9168 28.3138 28.7826 28.1779 28.6174 28.178C28.4521 28.178 28.3182 28.3136 28.3182 28.4811L28.3183 31.6967L25.1439 31.6967C24.9786 31.6967 24.8447 31.8323 24.8447 31.9998C24.8446 32.1671 24.9787 32.303 25.1439 32.3028L28.3183 32.3029L28.3183 35.5185C28.3182 35.6858 28.4523 35.8217 28.6175 35.8215C28.7002 35.8215 28.7749 35.7875 28.8291 35.7327C28.8833 35.6778 28.9167 35.6022 28.9167 35.5185L28.9167 32.3029L32.091 32.3029C32.1737 32.3029 32.2485 32.2689 32.3026 32.214C32.3568 32.1591 32.3902 32.0836 32.3902 31.9998C32.3904 31.8325 32.2562 31.6966 32.091 31.6968L28.9166 31.6967Z",
    fill: "#5A52C3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9166 31.6967L28.9166 28.4811C28.9168 28.3138 28.7826 28.1779 28.6174 28.178C28.4521 28.178 28.3182 28.3136 28.3182 28.4811L28.3183 31.6967L25.1439 31.6967C24.9786 31.6967 24.8447 31.8323 24.8447 31.9998C24.8446 32.1671 24.9787 32.303 25.1439 32.3028L28.3183 32.3029L28.3183 35.5185C28.3182 35.6858 28.4523 35.8217 28.6175 35.8215C28.7002 35.8215 28.7749 35.7875 28.8291 35.7327C28.8833 35.6778 28.9167 35.6022 28.9167 35.5185L28.9167 32.3029L32.091 32.3029C32.1737 32.3029 32.2485 32.2689 32.3026 32.214C32.3568 32.1591 32.3902 32.0836 32.3902 31.9998C32.3904 31.8325 32.2562 31.6966 32.091 31.6968L28.9166 31.6967",
    stroke: "#5A52C3",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeTextCaseIcon);
export default __webpack_public_path__ + "static/media/freeTextCaseIcon.7ee6bb85a8eb4f94f29b37a085b465fb.svg";
export { ForwardRef as ReactComponent };